import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_DoubleWrite = _resolveComponent("DoubleWrite", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.environment=='PROD')
      ? (_openBlock(), _createBlock(_component_BreadCrumb, {
          key: 0,
          PageTitle: _ctx.$t('breadCrumb.doubleentrylist')
        }, null, 8, ["PageTitle"]))
      : _createCommentVNode("", true),
    (_ctx.environment=='DEMO')
      ? (_openBlock(), _createBlock(_component_BreadCrumb, {
          key: 1,
          PageTitle: _ctx.$t('breadCrumb.doubleentrylist')
        }, null, 8, ["PageTitle"]))
      : _createCommentVNode("", true),
    _createVNode(_component_DoubleWrite)
  ], 64))
}